import {PaymentOnTrial, PaymentFailed, PaymentSucceeded, PaymentDisputing, PaymentRegistered, PaymentUnregistered} from '../../app';

export default class ProfileSelectionController {
  constructor(AuthService, $state, LoginService, ProfilePermissionsService, AccountInformationService, Notification) {
    this.authService = AuthService;
    this.state = $state;
    this.loginService = LoginService;
    this.permissionsService = ProfilePermissionsService;
    this.accountInfoService = AccountInformationService;
    this.notify = Notification;
    this.subscriptions = [];
  }
  
  $onInit() {
    this.subscriptions = [];
    this.permissionsService.setProfilesCount(this.profiles ? this.profiles.length : 0);
    this.invitations = [];

    this.authService.removeAccountToken();
    this.permissionsService.clearProfile();
  }

  $onDestroy() {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }

  selectProfile(profile) {
    this.subscriptions.push(
      this.loginService.getAccountToken(profile.account_id).subscribe((accountToken) => {
        if (!accountToken) {
          return;
        }

        this.authService.saveAccountToken(accountToken);
        this.permissionsService.setProfile(profile);

        let role = this.authService.parseJwt(accountToken).role;
        if (['MASTER', 'ADMIN'].indexOf(role) > -1) {
          this.state.go('userControl');
        } else {
          this.accountInfoService.getPaymentStatus().subscribe(data => {
            if(![PaymentOnTrial, PaymentRegistered, PaymentSucceeded].includes(data.payment_status)) {
              if (this.permissionsService.hasPermission('manage-subscription')) {
                if (data.payment_status === PaymentUnregistered) {
                  return this.state.go('accountSubscription');
                }

                return this.state.go('accountInformation');
              }

              return this.state.go('paymentNotice');
            }

            return this.state.go('dashboard');
          });
        }
      })
    );
  }

  logout() {
    this.subscriptions.push(
      this.authService.logout().subscribe(
        (data) => this.state.go('login'),
        (error) => { }
      )
    );
  }
}

ProfileSelectionController.$inject = ['AuthService', '$state', 'LoginService', 'ProfilePermissionsService', 'AccountInformationService', 'Notification'];


// WEBPACK FOOTER //
// ./src/app/pages/profile-selection/profile-selection.controller.js